export  const emailTemplate = `
<html lang="ko"><head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>LANDBOX</title>
</head>
<body style="margin: 0; padding: 20px; min-height: 100vh; background-color: #ffffff; display: flex; justify-content: center; align-items: center; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;">
    <div style="width: 100%; max-width: 600px;">
        <!-- Logo -->

        <!-- Main Content Box -->
        <div style="border: 1px solid #e0e0e0; border-radius: 4px; padding: 40px; margin-bottom: 40px; background-color: #ffffff;">
            <p style="font-size: 16px; color: #333333; margin: 0 0 30px 0; text-align: center;">##메세지</p>
            
            <hr style="border: none; height: 1px; background-color: #e0e0e0; margin: 30px 0;">
            
            <p style="font-size: 16px; color: #333333; margin: 0 0 20px 0; text-align: center;">#여행사명에서 제공하는 여행 일정표를 공유드립니다.</p>
            
            <p style="font-size: 14px; color: #666666; margin: 0 0 30px 0; text-align: center;">아래 링크를 클릭해 주세요.</p>
            
            <div style="text-align: center;">
                <a href="#url" style="display: inline-block; background-color: #ff4b13; color: #ffffff; text-decoration: none; padding: 12px 24px; border-radius: 4px; font-size: 16px;">
                    📅 일정표 확인하기
                </a>
            </div>
        </div>
        
        <!-- Notice -->
        <p style="font-size: 12px; color: #666666; margin: 0 0 40px 0; text-align: center;">
            이 메일은 발신 전용으로, 회신이 불가능합니다. 문의사항이 있으시면 위의 연락처를 이용해주시기 바랍니다.
        </p>
        
        <!-- Footer -->
        <hr style="width: 100%; color: gray; background-color: gray; height: 1px; border: none;">
        <div style="text-align: left; color: #666666; font-size: 12px; line-height: 1.6;">
        
            <p style="margin: 0;">#여행사명</p>
            <p style="margin: 0;">##여행사주소</p>
            <p style="margin: 0;">대표: ##대표자명</p>
            <p style="margin: 0;">고객센터 ##대표이메일</p>
            <p style="margin: 0;">운영시간 ##운영시간</p>
        </div>
        
        <!-- Copyright -->
        <p style="font-size: 12px; color: #999999; margin: 20px 0 0 0;">
            Copyright ##발송년도 #여행사명 All rights reserved.
        </p>
    </div>


</body></html>
`

export  const emailTemplate1 = `<html lang="ko">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Invitation to Landbox</title>
</head>
<body style="margin: 0; padding: 40px;  background-color: #1a1a1a; display: flex; justify-content: center; align-items: center; font-family: Arial, sans-serif;">
    <div style="position: relative; width: 100%; max-width: 600px; padding: 60px; background-color: #1a1a1a; border: 2px solid #c4a45f;">
        <h1 style="color: #c4a45f; text-align: center; font-size: 42px; margin: 0 0 50px; font-style: italic; font-weight: normal;">Invitation to Landbox</h1>
        <p style="color: #ffffff; text-align: center; font-size: 18px; margin: 30px 0; font-weight: normal;">##메세지</p>
        
        <div style="width: 100%; height: 1px; background-color: #c4a45f; margin: 40px 0;"></div>
        
        <p style="color: #ffffff; text-align: center; font-size: 16px; margin: 30px 0; line-height: 1.6;">#여행사명에서 제공하는 여행 일정표를 공유드립니다.</p>
        <p style="color: #ffffff; text-align: center; font-size: 16px; margin: 30px 0; line-height: 1.6;">아래 링크를 클릭해 주세요.</p>
        
        <div style="text-align: center; margin: 40px 0;">
            <a href="#url" style="display: inline-block; padding: 15px 40px; background-color: #c4a45f; color: #1a1a1a; text-decoration: none; border-radius: 5px; font-size: 16px; font-weight: bold;">
                📅 일정표 확인하기
            </a>
        </div>

        <div style="width: 100%; height: 1px; background-color: #c4a45f; margin: 40px 0;"></div>

        <p style="color: #888888; font-size: 12px; text-align: center; margin: 20px 0;">이 메일은 발신 전용으로, 회신이 불가능합니다. 문의사항이 있으시면 위의 연락처를 이용해주시기 바랍니다.</p>

        <div style="margin-top: 60px; text-align: center; color: #888888; font-size: 14px; line-height: 1.8;">
            #여행사명<br>
            ##여행사주소<br>
            대표: ##대표자명<br>
            고객센터 ##대표이메일<br>
            운영시간 #운영시간
        </div>
        
        <p style="margin-top: 20px; color: #666666; font-size: 12px; text-align: center;">Copyright #발송년도 #여행사명 All rights reserved.</p>
    </div>
</body>
</html>`;


